/**
 * Global message queue to ensure messages are rendered sequentially
 * even across multiple AJAX/WebSocket responses.
 */
class MessageQueue {
    constructor() {
        this.queue = Promise.resolve();
    }

    /**
     * Add a task to the queue
     * @param {Function} task - A function that returns a Promise
     * @returns {Promise}
     */
    addToQueue(task) {
        this.queue = this.queue.then(async () => {
            try {
                await task();
            } catch (error) {
                console.error('MessageQueue error:', error);
            }
        });
        return this.queue;
    }
}

// Create a singleton instance
export const messageQueue = new MessageQueue();
